import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { Subject } from 'rxjs';

import { UtilitiesService } from '@services/utilities.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  public title$: Subject<string> = new Subject<string>();

  constructor(private titleService: Title, private utilitiesService: UtilitiesService) { }

  public nextTitle(value: string): void {
    const title: string = this.utilitiesService.capitalizeFirstLetter(value);

    this.title$.next(title);
    this.titleService.setTitle(title);
  }
}
